export default "__VITE_ASSET__Bkxdg6nK__"